/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerAppToolCallRequest
 */
export interface PlannerAppToolCallRequest {
    /**
     * 
     * @type {string}
     * @memberof PlannerAppToolCallRequest
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof PlannerAppToolCallRequest
     */
    arguments?: object | null;
}

/**
 * Check if a given object implements the PlannerAppToolCallRequest interface.
 */
export function instanceOfPlannerAppToolCallRequest(value: object): value is PlannerAppToolCallRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PlannerAppToolCallRequestFromJSON(json: any): PlannerAppToolCallRequest {
    return PlannerAppToolCallRequestFromJSONTyped(json, false);
}

export function PlannerAppToolCallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerAppToolCallRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'arguments': json['arguments'] == null ? undefined : json['arguments'],
    };
}

export function PlannerAppToolCallRequestToJSON(json: any): PlannerAppToolCallRequest {
    return PlannerAppToolCallRequestToJSONTyped(json, false);
}

export function PlannerAppToolCallRequestToJSONTyped(value?: PlannerAppToolCallRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'arguments': value['arguments'],
    };
}

